<template>
	<div class="col-md-7 col-lg-8 wrapper-rounded-content content-mydata">
		<div class="bg-blue-multiply rounded-corners"></div>
		<div class="row justify-content-center headinline">
			<div class="col-md-12">
				<h1 class="d-inline-block">{{ $t('Meine Daten') }}</h1>
			</div>
		</div>


		<div class="row justify-content-center no-gutters pl-4 pr-4 mb-5" v-if="customer_data && customer_data.name">
			<div class="col-lg-6 pr-2">
				<div class="sum-item">
					<div class="row">
						<div class="col align-self-center">
							<p v-if="!editData">
								<small>{{ customer_data.salutation_string }}</small><br>
								{{ customer_data.firstname }} {{ customer_data.lastname }}<br>
								{{ customer_data.street }}<br>
								{{ customer_data.zipcode }} {{ customer_data.city }}<br><br>
								{{ customer_data.phone }}

							</p>
							<form v-else v-on:submit.prevent>
								<CsInput
									type="text"
									autocomplete="firstname"

									:validate="{'required':true}"
									:placeholder="$t('First name')"
									:id="'firstname'"
									:name="'firstname'"
									v-model="customer_data.firstname"
									></CsInput>
								<CsInput
									type="text"
									autocomplete="lastname"

									:validate="{'required':true}"
									:placeholder="$t('Last name')"
									:id="'lastname'"
									:name="'lastname'"
									v-model="customer_data.lastname"
									></CsInput>
								<CsInput
									type="text"
									autocomplete="street"

									:validate="{'required':true}"
									:placeholder="$t('Street, number')"
									:id="'street'"
									:name="'street'"
									v-model="customer_data.street"
									></CsInput>
								<CsInput
									type="text"
									autocomplete="zipcode"

									:validate="{'required':true}"
									:placeholder="$t('Zip code')"
									:id="'zipcode'"
									:name="'zipcode'"
									v-model="customer_data.zipcode"
									></CsInput>
								<CsInput
									type="text"
									autocomplete="city"

									:validate="{'required':true}"
									:placeholder="$t('City')"
									:id="'city'"
									:name="'city'"
									v-model="customer_data.city"
									></CsInput>
								<CsInput
									type="text"
									autocomplete="phone"
									:placeholder="$t('Telephone number')"
									:id="'phone'"
									:name="'phone'"
									v-model="customer_data.phone"
									></CsInput>
									<CsInput
									type="text"
									autocomplete="bill_recipient"
									:placeholder="$t('bill_recipient')"
									:id="'bill_recipient'"
									:name="'bill_recipient'"
									v-model="customer_data.bill_recipient"
									></CsInput>
								

								<CsInput
									type="text"
									autocomplete="is_carsharing_customer"
									:placeholder="$t('is_carsharing_customer')"
									:id="'is_carsharing_customer'"
									:name="'is_carsharing_customer'"
									v-model="customer_data.is_carsharing_customer"
									></CsInput>
									<CsInput
									type="text"
									autocomplete="payment_verified"
									:placeholder="$t('payment_verified')"
									:id="'payment_verified'"
									:name="'payment_verified'"
									v-model="customer_data.payment_verified"
									></CsInput>
									<CsInput
									type="text"
									autocomplete="payment_type"
									:placeholder="$t('payment_type')"
									:id="'payment_type'"
									:name="'payment_type'"
									v-model="customer_data.payment_type"
									></CsInput>
									<CsInput
									type="text"
									autocomplete="payment_customer"
									:placeholder="$t('payment_customer')"
									:id="'payment_customer'"
									:name="'payment_customer'"
									v-model="customer_data.payment_customer"
									></CsInput>
									<CsInput
									type="text"
									autocomplete="payment_id"
									:placeholder="$t('payment_id')"
									:id="'payment_id'"
									:name="'payment_id'"
									v-model="customer_data.payment_id"
									></CsInput>
									
		

									<button type="button" @click.prevent="editData=false" class="btn btn-outline-info btn-wp">
										{{ $t('Abbrechen') }}
									</button>
									<button type="button" @click.prevent="changeData" class="btn btn-outline-info btn-wp">
										{{ $t('Bestätigen') }}
									</button>
									
							</form>

						</div>
						
						
					</div>
					<div class="row mt-4"  v-if="!customer_data.is_carsharing_customer">
						<div class="col align-self-center">
							<p>Der Account wurde noch nicht freigeschaltet.</p>
							<a v-if="customer_data.post_ident_url" :href="customer_data.post_ident_url" class="btn btn-primary btn-wp">Jetzt idenditifizieren!</a>
						</div>
					</div>
					<div class="row mt-4"  v-if="!customer_data.bill_recipient">
						<div class="col align-self-center">
							<!-- <p>Es wurde noch kein Zahlungsmittel hinterlegt.</p> -->
						</div>
					</div>
					<div class="row" v-if="editAllowed">
						<div class="col-auto align-self-center">
							<button type="button" v-if="!editData" @click="editData=true" class="btn btn-outline-info btn-wp">
								{{ $t('Account ändern') }}
							</button>
						</div>
					</div>
				</div>
			</div>


			<div class="col-lg-6 pl-2">
				<div class="sum-item">
					<div class="row">
						<div class="col">
							<div v-if="!editPassword">
								<small>{{ $t('E-mail Adresse') }}</small>
								<p v-if="!editEmail">{{ customer_data.email }}</p>
								<p v-else>
								<form v-if="editEmail" v-on:submit.prevent>
									<CsInput
										type="email"
										autocomplete="email"
										:placeholder="$t('Email address')"
										:id="'email'"
										:name="'email'"
										v-model="customer_data.email"
										></CsInput>
										<button type="button" @click.prevent="editEmail=false" class="btn btn-outline-info btn-wp">
											{{ $t('Abbrechen') }}
										</button>
										<button type="button" @click.prevent="changeData" class="btn btn-outline-info btn-wp">
											{{ $t('Bestätigen') }}
										</button>
										
								</form>
								</p>
							</div>
							<div v-else>
								<small>{{ $t('Password') }}</small>
								<form v-on:submit.prevent>
									<CsInput
										type="password"
										autocomplete="password"
										:placeholder="$t('password')"
										:id="'password'"
										:name="'password'"
										v-model="customer_data.password"
										></CsInput>
										<button type="button" @click.prevent="editPassword=false" class="btn btn-outline-info btn-wp">
											{{ $t('Abbrechen') }}
										</button>
										<button type="button" @click.prevent="changePassword" class="btn btn-outline-info btn-wp">
											{{ $t('Bestätigen') }}
										</button>
										
								</form>
								</p>
							</div>
							<!--
							<button type="button" v-if="!editEmail && !editPassword" @click="editEmail=true" class="btn btn-outline-info btn-wp">
								{{ $t('E-mail ändern') }}
							</button>-->
							<button type="button" v-if="!editEmail && !editPassword" @click="editPassword=true" class="btn btn-outline-info btn-wp">
								{{ $t('Passwort ändern') }}
							</button>
							<br>
						</div>
					</div>
					<div class="row" v-if="canDeleteAccount">
						<div class="col">
							<small @click="showModal" class="input_description--link">
								{{ $t('Account löschen') }}
							</small>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal v-show="isModalVisible" @clicked="closeModal" :isModalVisible="isModalVisible"	:largeModal="true" :twoButtons="true">
			<h3 slot="headline">{{ $t('Wollen Sie ihren Account wirklich löschen?') }}</h3>
			<template slot="firstBtn">{{ $t('Ja') }}</template>
			<template slot="closeBtn">{{ $t('Nein') }}</template>
		</modal>
		<div v-show="isModalVisible" @click="closeModal" class="modal-backdrop show"></div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'PageMyData',
	computed: {
	    ...mapGetters('orm/reservation', {
	    	user_session: 'user_session'
	    }),
	},
	data() {
		return {
			reservations: [],
			customer_data: {},
			editData: false,
			editEmail: false,
			editPassword: false,
			isModalVisible: false,
			canDeleteAccount: false,
			editAllowed:false
		};
	},
	methods: {
		showModal() {
			this.isModalVisible = true;
			document.body.classList.add("modal-open");
      	},
      	closeModal(value) {
      		switch (value) {
			  case 'close':
			  	break;
			  case 'submit':
			  	this.deleteAccount();
			  	break;
			  default:

			}
        	this.isModalVisible = false;
        	document.body.classList.remove("modal-open");
      	},
		deleteAccount(ev){
			console.log('delete');
			var self = this;
			if(!self.user_session) {
				//this.$router.push({name: "PageLogin", params: {redirect: 'PageSummary' }});
				console.log('No SESSION');
			} else {
			
				this.$store.dispatch('orm/DELETE_CUSTOMER', self.customer_data)
				.then(result => {
					//self.isModalVisible = true;
					console.log('RESULT', result);
					this.$store.dispatch('orm/LOGOUT_CUSTOMER')
					.then(res => {
						self.showMenu = !self.showMenu
						self.$router.push({ path: '/' })
					});

				})
				.catch(err => { this.$store.commit("core/ADD_ERROR", err); });
			}
		},
		changeData(ev){
			var self = this;
			if(!self.user_session) {
				//this.$router.push({name: "PageLogin", params: {redirect: 'PageSummary' }});
				console.log('No SESSION');
			} else {
				this.$store.dispatch('orm/CHANGE_CUSTOMER_DATA', self.customer_data)
				.then(result => {
					//self.isModalVisible = true;
					console.log('RESULT', result);
					self.editData = false;
					self.editEmail = false;
					self.editPassword = false;

				})
				.catch(err => { this.$store.commit("core/ADD_ERROR", err); });

			}
		},
		changePassword(ev){
			var self = this;
			if(!self.user_session) {
				//this.$router.push({name: "PageLogin", params: {redirect: 'PageSummary' }});
				console.log('No SESSION');
			} else {
				this.$store.dispatch('orm/CHANGE_CUSTOMER_PASSWORD', self.customer_data.password)
				.then(result => {
					//self.isModalVisible = true;
					console.log('RESULT', result);
					self.editData = false;
					self.editEmail = false;
					self.editPassword = false;

				})
				.catch(err => { this.$store.commit("core/ADD_ERROR", err); });

			}
		},

	},
	created() {
		var self = this;
		this.$emit("isActive", "mydata");
		this.$store.dispatch('orm/GET_CUSTOMER')
		.then(result => {
			console.log('GET_CUSTOMER', result)
			self.customer_data = result
		}).catch(err => { this.$store.commit("core/ADD_ERROR", err); })
	},
}


</script>



// WEBPACK FOOTER //
// src/components/Pages/PageMydata.vue